/**
 * Elings-maatwerk dat op elke pagina nodig is.
 * (custom.js stopt op pagina's zonder bestellijst, dus algemene code hoort hier.)
 */

// Snel bestellen op de productkaart: +/- in stappen van de hoeveelheidsregel (colli)
document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-quick-order-step]');
  if (!button) return;

  const input = button.parentElement.querySelector('.product-item__quick-order-input');
  if (!input) return;

  const step = parseInt(input.step, 10) || 1;
  const min = parseInt(input.min, 10) || 1;
  const max = parseInt(input.max, 10) || Infinity;
  const current = parseInt(input.value, 10) || min;
  const next = current + step * parseInt(button.dataset.quickOrderStep, 10);

  input.value = Math.min(max, Math.max(min, next));
});

// Handmatig ingevuld aantal afronden op de stap en binnen min/max houden
document.addEventListener('change', function (event) {
  const input = event.target.closest('.product-item__quick-order-input');
  if (!input) return;

  const step = parseInt(input.step, 10) || 1;
  const min = parseInt(input.min, 10) || 1;
  const max = parseInt(input.max, 10) || Infinity;
  const value = Math.round((parseInt(input.value, 10) || min) / step) * step;

  input.value = Math.min(max, Math.max(min, value));
});

// Raster/lijst wisselen: Warehouse verwisselt alleen de CSS-klassen, maar de Elings-kaart verschilt per
// weergave (in de lijst staan prijs en bestelblok rechts, zonder Warehouse-knoppen). Sla de keuze op
// zoals Warehouse dat doet en laad de pagina opnieuw, zodat de kaart in de juiste vorm terugkomt.
document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-action="change-layout"]');
  if (!button || button.classList.contains('is-selected')) return;

  event.stopPropagation();
  event.preventDefault();

  fetch(window.routes.cartUrl + '/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ attributes: { collection_layout: button.dataset.layoutMode } })
  }).finally(function () {
    window.location.reload();
  });
}, true);

/**
 * Filterkolom (snippets/elings-filters.liquid), zoals het Boost-menu van live.
 */

// Zoekveld boven een lange lijst (Brouwerij, Land van herkomst)
document.addEventListener('input', function (event) {
  const input = event.target.closest('[data-elings-filter-search]');
  if (!input) return;

  const term = input.value.trim().toLowerCase();
  input.closest('.elings-filter').querySelectorAll('[data-elings-filter-label]').forEach(function (item) {
    item.hidden = term !== '' && item.dataset.elingsFilterLabel.indexOf(term) === -1;
  });
});

// Enter in het zoekveld mag het filterformulier niet versturen
document.addEventListener('keydown', function (event) {
  if (event.key === 'Enter' && event.target.closest('[data-elings-filter-search]')) {
    event.preventDefault();
  }
});

// Bierstijlboom: een stijl kiezen filtert binnen de huidige collectie op het tagfilter. Eén stijl
// tegelijk: een andere stijl vervangt de vorige, nog eens klikken haalt hem weg. De overige filters
// (ook Glutenvrij) blijven staan. Warehouse laadt de URL daarna via data-action="clear-filters".
function elingsTreeTags(tree) {
  return Array.from(tree.querySelectorAll('[data-elings-tree-tag]')).map(function (item) {
    return item.dataset.elingsTreeTag;
  });
}

// De huidige URL-parameters zonder de gekozen bierstijl (en zonder paginanummer)
function elingsParamsWithoutStyle(treeTags) {
  const params = new URLSearchParams();
  new URLSearchParams(window.location.search).forEach(function (value, key) {
    if (key === 'page') return;
    if (key === 'filter.p.tag' && treeTags.indexOf(value) !== -1) return;
    params.append(key, value);
  });
  return params;
}

document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-elings-tree-tag]');
  if (!button) return;

  const params = elingsParamsWithoutStyle(elingsTreeTags(button.closest('.elings-tree')));

  if (button.getAttribute('aria-pressed') !== 'true') {
    params.append('filter.p.tag', button.dataset.elingsTreeTag);
  }

  const query = params.toString();
  button.setAttribute('data-url', window.location.pathname + (query ? '?' + query : ''));
}, true);

// Hoofdstijl zonder eigen tag (Wit/Weizen, Lager/Pilsener, Amber/Red): de naam klapt de substijlen open
document.addEventListener('click', function (event) {
  const label = event.target.closest('[data-elings-tree-open]');
  if (!label) return;

  label.closest('.elings-tree__row').querySelector('.elings-tree__toggle').click();
});

// Met een gekozen bierstijl telt Shopify alleen nog binnen die stijl, waardoor de andere stijlen uit de
// boom zouden verdwijnen. Haal de boom dan op zonder de gekozen stijl en markeer de keuze, zodat de
// klant direct naar een andere stijl kan.
function elingsSyncTrees() {
  document.querySelectorAll('.elings-tree').forEach(function (tree) {
    const active = tree.querySelector('[data-elings-tree-tag][aria-pressed="true"]');
    const group = tree.closest('.collection__filter-collapsible');
    const section = tree.closest('[data-section-id]');
    if (!active || !group || !section) return;

    const chosen = active.dataset.elingsTreeTag;
    const params = elingsParamsWithoutStyle(elingsTreeTags(tree));
    params.set('section_id', section.getAttribute('data-section-id'));

    fetch(window.location.pathname + '?' + params.toString(), { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.text() : ''; })
      .then(function (html) {
        const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById(group.id);
        const freshTree = fresh && fresh.querySelector('.elings-tree');
        if (!freshTree || !tree.isConnected) return;

        tree.innerHTML = freshTree.innerHTML;
        tree.querySelectorAll('[data-elings-tree-tag]').forEach(function (button) {
          if (button.dataset.elingsTreeTag !== chosen) return;

          button.classList.add('is-active');
          button.setAttribute('aria-pressed', 'true');

          const item = button.closest('.elings-tree__item');
          const subs = item.querySelector('.elings-tree__subs');
          const toggle = item.querySelector('.elings-tree__toggle');
          if (subs && toggle) {
            subs.setAttribute('aria-hidden', 'false');
            subs.style.height = 'auto';
            subs.style.overflow = 'visible';
            toggle.setAttribute('aria-expanded', 'true');
          }
        });
      })
      .catch(function () {});
  });
}

elingsSyncTrees();
document.addEventListener('theme:loading:end', elingsSyncTrees);

// Winkelwagen: opmerking opslaan zonder uitklapblok (Warehouse sluit na opslaan een
// uitklapblok dat er niet meer is, daarom een eigen knop)
document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-elings-save-note]');
  if (!button) return;

  const field = button.closest('.cart-recap__note').querySelector('[name="note"]');
  const label = button.dataset.label || button.textContent;
  button.dataset.label = label;
  button.disabled = true;

  fetch(window.routes.cartUrl + '/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ note: field.value })
  })
    .then(function (response) {
      button.textContent = response.ok ? button.dataset.savedLabel : label;
    })
    .catch(function () {})
    .finally(function () {
      button.disabled = false;
      setTimeout(function () { button.textContent = label; }, 2000);
    });
});

// Winkelwagen in één keer leegmaken (sections/main-cart.liquid). Eerst een bevestiging in de pagina,
// daarna /cart/clear.js en de pagina opnieuw laden. Via document, omdat het thema de winkelwagen na
// elke aantalwijziging opnieuw opbouwt.
document.addEventListener('click', function (event) {
  const blok = event.target.closest('[data-elings-leegmaken]');
  if (!blok) return;

  const knop = blok.querySelector('[data-elings-leegmaken-start]');
  const vraag = blok.querySelector('.elings-leegmaken__vraag');

  if (event.target.closest('[data-elings-leegmaken-start]')) {
    knop.hidden = true;
    vraag.hidden = false;
    blok.querySelector('[data-elings-leegmaken-annuleren]').focus();
    return;
  }

  if (event.target.closest('[data-elings-leegmaken-annuleren]')) {
    vraag.hidden = true;
    knop.hidden = false;
    knop.focus();
    return;
  }

  const bevestigen = event.target.closest('[data-elings-leegmaken-bevestigen]');
  if (!bevestigen) return;

  bevestigen.disabled = true;
  bevestigen.textContent = 'Bezig met leegmaken…';
  fetch(`${window.routes.cartClearUrl || '/cart/clear'}.js`, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  }).then(function () {
    window.location.reload();
  }).catch(function () {
    bevestigen.disabled = false;
    bevestigen.textContent = 'Ja, leegmaken';
  });
});

// Escape sluit de vraag weer
document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;
  const vraag = document.querySelector('.elings-leegmaken__vraag:not([hidden])');
  if (!vraag) return;
  const blok = vraag.closest('[data-elings-leegmaken]');
  vraag.hidden = true;
  blok.querySelector('[data-elings-leegmaken-start]').hidden = false;
});

// Zoek-pop-up in de kop (sections/header.liquid, sections/predictive-search.liquid), zoals de oude
// Boost-pop-up. Recente zoekopdrachten van deze bezoeker staan in localStorage; ze worden bewaard
// zodra de zoekpagina opent en bij een klik op een product in de pop-up. De populaire producten
// (sections/elings-zoek-populair.liquid) worden pas bij de eerste klik in de zoekbalk opgehaald.
const ELINGS_RECENT_SLEUTEL = 'elings_recente_zoekopdrachten';
const ELINGS_RECENT_MAX = 5;

function elingsRecentLezen() {
  try {
    const lijst = JSON.parse(localStorage.getItem(ELINGS_RECENT_SLEUTEL) || '[]');
    return Array.isArray(lijst) ? lijst.filter(function (term) { return typeof term === 'string'; }) : [];
  } catch (e) {
    return [];
  }
}

function elingsRecentOpslaan(term) {
  // Zonder het producttypefilter van de zoekbalk en het jokerteken
  term = (term || '').replace(/^product_type:.*? AND /i, '').replace(/^product_type:\S*$/i, '')
    .replace(/\*$/, '').replace(/\s+/g, ' ').trim();
  if (term === '' || term.length > 80) return;

  const lijst = elingsRecentLezen().filter(function (oud) { return oud.toLowerCase() !== term.toLowerCase(); });
  lijst.unshift(term);
  try {
    localStorage.setItem(ELINGS_RECENT_SLEUTEL, JSON.stringify(lijst.slice(0, ELINGS_RECENT_MAX)));
  } catch (e) {}
}

function elingsRecentTonen() {
  const lijst = elingsRecentLezen().slice(0, ELINGS_RECENT_MAX);
  const zoekUrl = (window.routes && window.routes.searchUrl) || '/search';

  document.querySelectorAll('[data-elings-recent]').forEach(function (blok) {
    const ul = blok.querySelector('[data-elings-recent-lijst]');
    ul.textContent = '';
    lijst.forEach(function (term) {
      const a = document.createElement('a');
      a.className = 'search-bar__result-link';
      a.href = `${zoekUrl}?${new URLSearchParams({ q: term, type: 'product' })}`;
      a.textContent = term;
      const li = document.createElement('li');
      li.appendChild(a);
      ul.appendChild(li);
    });
    blok.hidden = lijst.length === 0;
  });
}

const ELINGS_POPULAIR_SLEUTEL = 'elings_populaire_producten';
const ELINGS_POPULAIR_GELDIG = 30 * 60 * 1000;

// Populaire producten in het paneel zetten: uit sessionStorage als die er (voor deze collectie en deze
// bezoeker, en minder dan een half uur oud) is, anders ophalen. Mislukt dat, dan verdwijnt het blok.
function elingsPopulairLaden() {
  document.querySelectorAll('[data-elings-populair][data-url]').forEach(function (blok) {
    const url = blok.dataset.url;
    const sleutel = blok.dataset.sleutel || url;
    const lijst = blok.querySelector('[data-elings-populair-lijst]');
    blok.removeAttribute('data-url');

    try {
      const bewaard = JSON.parse(sessionStorage.getItem(ELINGS_POPULAIR_SLEUTEL) || 'null');
      if (bewaard && bewaard.sleutel === sleutel && Date.now() - bewaard.tijd < ELINGS_POPULAIR_GELDIG) {
        lijst.innerHTML = bewaard.html;
        return;
      }
    } catch (e) {}

    fetch(url, { credentials: 'same-origin' }).then(function (response) {
      return response.ok ? response.text() : '';
    }).then(function (html) {
      const div = document.createElement('div');
      div.innerHTML = html;
      const inhoud = div.querySelector('.elings-zoek-populair');
      if (!inhoud || !inhoud.querySelector('.elings-zoek__product')) {
        blok.hidden = true;
        return;
      }
      lijst.innerHTML = inhoud.innerHTML;
      try {
        sessionStorage.setItem(ELINGS_POPULAIR_SLEUTEL, JSON.stringify({ sleutel: sleutel, tijd: Date.now(), html: inhoud.innerHTML }));
      } catch (e) {}
    }).catch(function () {
      blok.hidden = true;
    });
  });
}

// Vooraf laden zodra de pagina rustig is, zodat het paneel bij de eerste klik al compleet is
if ('requestIdleCallback' in window) {
  window.requestIdleCallback(elingsPopulairLaden, { timeout: 3000 });
} else {
  window.addEventListener('load', function () { setTimeout(elingsPopulairLaden, 500); });
}

(function () {
  const params = new URLSearchParams(window.location.search);
  if (/\/search\/?$/.test(window.location.pathname) && params.get('q')) {
    elingsRecentOpslaan(params.get('q'));
  }
  elingsRecentTonen();
})();

// De pop-up begint links bij het zoekveld en mag rechts niet buiten beeld lopen (theme.css)
function elingsZoekRuimte() {
  document.querySelectorAll('.search-bar').forEach(function (balk) {
    const ruimte = window.innerWidth - balk.getBoundingClientRect().left - 20;
    balk.style.setProperty('--elings-zoek-ruimte', `${Math.round(ruimte)}px`);
  });
}

window.addEventListener('resize', elingsZoekRuimte);

document.addEventListener('focusin', function (event) {
  if (!event.target.closest('.search-bar__input')) return;
  elingsZoekRuimte();
  elingsRecentTonen();
  elingsPopulairLaden();
});

document.addEventListener('click', function (event) {
  if (event.target.closest('[data-elings-recent-wissen]')) {
    try {
      localStorage.removeItem(ELINGS_RECENT_SLEUTEL);
    } catch (e) {}
    elingsRecentTonen();
    return;
  }

  // Product aangeklikt tijdens het typen: de zoekterm telt ook als recente zoekopdracht
  const product = event.target.closest('.search-bar__results .elings-zoek__product');
  if (!product) return;
  const input = product.closest('.search-bar').querySelector('.search-bar__input');
  if (input) elingsRecentOpslaan(input.value);
});

/**
 * Zoekresultaten sorteren op datum (zie bovenaan sections/main-search.liquid). De zoekfunctie van Shopify sorteert
 * alleen op relevantie en prijs. Bij sort_by=created-… laat de sectie de productlijst leeg; hier halen we per 250
 * resultaten id en aanmaakdatum op (sections/elings-zoek-datum.liquid), sorteren alles en halen daarna de kaarten
 * van de gevraagde pagina per product op (templates/product.elings-kaart.liquid).
 */
const ELINGS_DATUM_PER_KEER = 250;
const elingsDatumCache = {};

// Alle resultaten als [{handle, tijd}], gesorteerd; per zoekopdracht, filter en richting één keer ophalen
function elingsDatumVolgorde(lijst) {
  const params = new URLSearchParams(window.location.search);
  params.delete('page');
  params.delete('section_id');
  const sleutel = params.toString();
  if (elingsDatumCache[sleutel]) return elingsDatumCache[sleutel];

  const aantal = Math.min(parseInt(lijst.dataset.count, 10) || 0, 1000);
  const delen = [];
  for (let deel = 1; deel <= Math.ceil(aantal / ELINGS_DATUM_PER_KEER); deel++) {
    params.set('page', deel);
    params.set('section_id', 'elings-zoek-datum');
    delen.push(fetch(window.location.pathname + '?' + params.toString(), { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error(response.status);
      return response.text();
    }).then(function (html) {
      const script = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-elings-datum-lijst]');
      if (!script) throw new Error('geen datums');
      return JSON.parse(script.textContent).map(function (rij) {
        return { handle: rij[1], tijd: rij[2] };
      });
    }));
  }

  const nieuwOud = lijst.dataset.elingsDatum === 'created-descending';
  elingsDatumCache[sleutel] = Promise.all(delen).then(function (resultaten) {
    // Bij gelijke datum blijft de volgorde van relevantie staan (sort is stabiel)
    return [].concat.apply([], resultaten).sort(function (a, b) {
      return nieuwOud ? b.tijd - a.tijd : a.tijd - b.tijd;
    });
  }).catch(function (fout) {
    delete elingsDatumCache[sleutel];
    throw fout;
  });
  return elingsDatumCache[sleutel];
}

function elingsDatumKaart(handle) {
  return fetch(window.routes.rootUrlWithoutSlash + '/products/' + encodeURIComponent(handle) + '?view=elings-kaart', { credentials: 'same-origin' }).then(function (response) {
    if (!response.ok) return null;
    return response.text().then(function (html) {
      return document.createRange().createContextualFragment(html).querySelector('.product-item');
    });
  }).catch(function () {
    return null;
  });
}

function elingsDatumVullen(lijst) {
  lijst.dataset.elingsGeladen = 'true';
  document.dispatchEvent(new CustomEvent('theme:loading:start'));

  const pagina = parseInt(lijst.dataset.page, 10) || 1;
  const perPagina = parseInt(lijst.dataset.perPage, 10) || 48;

  elingsDatumVolgorde(lijst).then(function (volgorde) {
    const handles = volgorde.slice((pagina - 1) * perPagina, pagina * perPagina).map(function (item) {
      return item.handle;
    });
    return Promise.all(handles.map(elingsDatumKaart));
  }).then(function (kaarten) {
    if (!lijst.isConnected) return;
    kaarten = kaarten.filter(Boolean);
    // Kolomklassen van de sectie, zoals Warehouse ze zet bij het wisselen van raster en lijst
    kaarten.forEach(function (kaart) {
      if (kaart.classList.contains('product-item--vertical')) {
        kaart.className = 'product-item product-item--vertical ' + lijst.dataset.gridClasses;
      }
    });
    lijst.replaceChildren.apply(lijst, kaarten);
  }).catch(function () {
    if (lijst.isConnected) {
      lijst.textContent = 'Sorteren op datum lukt nu niet. Laad de pagina opnieuw of kies een andere sortering.';
    }
  }).finally(function () {
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
  });
}

function elingsDatumZoeken() {
  document.querySelectorAll('[data-elings-datum]:not([data-elings-geladen])').forEach(elingsDatumVullen);
}

// Bij het laden, en wanneer Warehouse de resultaten vervangt (sorteren, filteren, bladeren)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', elingsDatumZoeken);
} else {
  elingsDatumZoeken();
}
if (window.location.pathname.indexOf('/search') !== -1) {
  new MutationObserver(elingsDatumZoeken).observe(document.documentElement, { childList: true, subtree: true });
}
